import { Tooltip } from "@mantine/core";

import { colors } from "#app/theme/v1/colors";
import { fontSizes } from "#app/theme/v1/fontSizes";
import { Icon, IconName } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";

import classes from "./RecommendButton.module.css";

type Props = {
  onClick?: () => void;
  iconName: IconName;
  active?: boolean;
  disabled?: boolean;
  tooltip?: string;
};

export const RecommendButton = ({ onClick, iconName, active, disabled, tooltip }: Props) => {
  return (
    <Tooltip label={tooltip} disabled={!tooltip}>
      <ActionIcon
        onClick={onClick}
        variant={"outline"}
        // can't use theme as described in the documentation https://mantine.dev/core/action-icon/#colors
        color={active ? "blue.5" : "grey.3"}
        radius={"sm"}
        mr="xxs"
        p="xs"
        disabled={disabled}
        className={classes.actionIcon}
        tabIndex={-1}
      >
        <Icon
          name={iconName}
          color={disabled ? colors.gray[4] : colors.blue[5]}
          size={parseInt(fontSizes.small)}
        />
      </ActionIcon>
    </Tooltip>
  );
};
